import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { Flex, Box, Button } from 'components';

const Opacity = styled(Flex)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
`;

const WrapperScroll = styled(Box)`
  position: fixed;

  background: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  border-radius: 4px;

  ${({ theme: { mediaQueries } }) => {
    return `

    ${mediaQueries.mobile} {
        width: 90%;
        height: 90%;
      }

      ${mediaQueries.tablet} {
        width: 80%;
        height: 80%;
      }

      ${mediaQueries.desktop} {
        width: 70%;
        height: 70%;
      }
    `;
  }}
`;

interface TermProps {
  hideTerm: () => void;
}

const Term = ({ hideTerm }: TermProps): ReactElement => (
  <>
    <Opacity>
      <WrapperScroll>
        <Box p={{ m: 20, t: 30, d: 50 }} fontSize="0.850rem">
          <p>
            <strong>Obrigado pelo interesse em participar do Curso Preparatório ANCORD oferecido pela MELVER S/A.</strong>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>
              Antes de prosseguir com a contratação, é fundamental que leia atentamente as condições e cláusulas adiante pormenorizados, e compreenda
              todos os termos que regulam a aquisição do programa.
            </strong>
          </p>
          <p>&nbsp;</p>
          <p style={{ textAlign: 'center' }}>
            <strong>TERMO DE ADESÃO PARA</strong> <strong>CURSO PREPARATÓRIO ANCORD</strong>
          </p>
          <br />
          <Box bg="gray_200" border="1px solid" borderColor="gray_300" p={3}>
            <p>
              <strong>CONTRATADA: MELVER S/A,</strong> pessoa jurídica de direito privado, inscrita no cadastro nacional de pessoas jurídicas sob o nº
              40.919.092/0001-22, inscrição municipal nº 5750750, com sede na Avenida Afonso Delambert Neto, nº 103, sala nº 04 – Lagoa da Conceição,
              CEP nº 88062-000, Florianópolis, Estado de Santa Catarina; <strong>doravante denominada CONTRATADA</strong>.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>CONTRATANTE:</strong> Aluno(a) que se inscrever, preenchendo corretamente todos os seus dados na ficha de inscrição deste curso,
              disponibilizada na plataforma online da CONTRATADA; <strong>doravante denominado(a) CONTRATANTE</strong>.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>OBJETO</strong>: Adesão ao curso e materiais didáticos para o Curso Preparatório ANCORD.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>PRAZO</strong>: Determinado e vinculado à conclusão do Curso Preparatório ANCORD.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>VALOR</strong>: R$ 600,00 (seiscentos reais) à vista, ou parcelamento via cartão de crédito, com acréscimos legais – conforme
              operadora, a ser confirmado no ato da contratação pelo(a) próprio(a) CONTRATANTE.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>NATUREZA LEGAL</strong>: Lei nº 10.406/2002.
            </p>
          </Box>
          <br />
          <p style={{ textAlign: 'center' }}>
            <strong>I - CONSIDERAÇÕES PRELIMINARES:</strong>
          </p>

          <ol>
            <li>
              Considerando que a empresa CONTRATADA possui know-how na área educacional, oferece ao(à) CONTRATANTE seu escopo técnico-profissional
              para o desenvolvimento do Curso Preparatório ANCORD a ser disponibilizada ao(à) CONTRATANTE;
            </li>
            <li>Os conteúdos serão disponibilizados em uma plataforma própria da CONTRATADA.</li>
            <li>Além disso, o programa conta com lives de profissionais de referência no mercado;</li>
            <li>
              O Curso Preparatório ANCORD adquirido é de uso <strong>pessoal e individual</strong> e tem caráter meramente educativo, razão pela qual
              a CONTRATADA e seus colaboradores não se responsabilizam&nbsp;por qualquer ação ou decisão executada com base em suas informações e em
              seu conteúdo.
            </li>
          </ol>
          <p>&nbsp;</p>
          <p style={{ textAlign: 'center' }}>
            <strong>II - CONDIÇÕES ESPECÍFICAS:</strong>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 1ª - Do objeto do contrato e valor:</strong> O objeto deste contrato constitui na prestação de serviços para aplicação de
            conteúdos sobre o mercado financeiro, a ser disponibilizada ao(à) CONTRATANTE. Referido curso será realizado de forma on-line.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo único: Ter-se-á, para devidos fins, o valor inicial do Curso Preparatório ANCORD, material e conteúdo o valor de R$ 600,00
            (seiscentos reais).
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 2ª - Do prazo:</strong> O prazo de vigência deste instrumento persistirá pelo período de duração do Curso Preparatório
            ANCORD, acrescido de 180 (cento e oitenta) dias.
          </p>
          <p>&nbsp;</p>
          <p>Parágrafo único: Vencido o prazo ajustado originalmente, o presente negócio jurídico não se prorrogará automaticamente.&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 3ª - Dos serviços contratados:</strong> A CONTRATADA, durante o período de vigência do presente instrumento, prestará os
            seguintes serviços ao(à) CONTRATANTE:
          </p>

          <ol>
            <li>Apoio técnico-profissional para o melhor desenvolvimento dos serviços contratados;</li>
            <li>Elaboração de todo o material e conteúdo contratado;</li>
            <li>Disponibilização de todo o material e conteúdo em plataforma própria da CONTRATADA;</li>
            <li>Lives de profissionais de referência no mercado;</li>
          </ol>
          <p>&nbsp;</p>
          <p>
            Parágrafo único: O acesso ao curso somente será efetivado com o correto preenchimento do cadastro da ficha de inscrição disponibilizada
            ao(à) CONTRATANTE na plataforma on-line da CONTRATADA, e ainda, após a confirmação do login e senha do usuário fornecidos pela CONTRATADA
            por e-mail.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 4ª - Das obrigações da CONTRATADA:</strong> Constituem obrigações da CONTRATADA para com o(a) CONTRATANTE, visando o fiel
            e integral cumprimento do presente contrato de prestação de serviços:
          </p>

          <ol>
            <li>Cumprir rigorosamente os serviços descritos neste contrato;</li>
            <li>Manter-se atualizada nas técnicas inerentes à prestação dos serviços objeto do presente;</li>
            <li>Zelar para que a qualidade seja mantida dentro dos padrões de excelência nacional e internacional;</li>
            <li>
              Responsabilizar-se, com exclusividade, por todos e eventuais funcionários, colaboradores, mentores, palestrantes, e quaisquer outros
              profissionais que lhe prestem serviços, em favor do cumprimento da legislação fiscal, previdenciária, securitária e trabalhista
              vigentes, não havendo, portanto, qualquer vínculo empregatício entre os contratantes, bem como para o regular atendimento às obrigações
              sociais, civis, tributárias, fiscais e trabalhistas decorrentes da execução deste contrato;
            </li>
            <li>
              Permitir acesso do(a) CONTRATANTE ao conteúdo e aos materiais disponibilizados na plataforma MELVER (CONTRATADA). O acesso a plataforma
              educacional ficará disponível por 180 (cento e oitenta dias) dias corridos após o encerramento do curso;
            </li>
            <li>
              A CONTRATADA não se responsabiliza por eventuais problemas decorrentes da interrupção dos serviços de provedor de acesso à internet
              do(a) CONTRATANTE, nem mesmo pela paralisação do fornecimento de energia elétrica para o funcionamento do sistema de seu provedor de
              acesso, falhas nos sistemas de transmissão ou de roteamento de acesso à internet, incompatibilidade dos sistemas dos usuários com os do
              provedor de acesso, ou qualquer ação de terceiros que impeçam a prestação de serviço resultante de caso fortuito ou de força maior
              relacionados no Código Civil Brasileiro;
            </li>
            <li>
              Emitir o Certificado de Conclusão do Curso, ao(à) aluno(a) (CONTRATANTE) que tenha cumprido 90% (noventa por cento) da programação em
              até 180 (cento e oitenta) dias após encerramento do Curso Preparatório ANCORD.
            </li>
            <li>&nbsp;</li>
          </ol>
          <p>
            <strong>Cláusula 5ª - Das obrigações do(a) CONTRATANTE:</strong> O(A) <strong>CONTRATANTE</strong> desde já, reconhece e se obriga a:
          </p>

          <ol>
            <li>
              Cumprir os requisitos exigidos para realização do Curso Preparatório ANCORD, quitando o valor correspondente ao presente instrumento nas
              condições oferecidas pela CONTRATADA;
            </li>
            <li>Responder, no prazo estabelecido pela CONTRATADA, todas as mensagens recebidas;</li>
            <li>
              Enviar os trabalhos, projetos, resumos etc. (caso existam) para avaliação, dentro do prazo estabelecido pela CONTRATADA e todos os seus
              colaboradores;
            </li>
            <li>
              Manter seus dados cadastrais atualizados e com informações verídicas, bem como zelar pela confidencialidade de sua senha e de seu login,
              de forma a não permitir seu compartilhamento com terceiros;
            </li>
            <li>Honrar com os compromissos e prazos assumidos no aceite deste contrato;</li>
            <li>Não violar a privacidade de outros usuários;</li>
            <li>Não utilizar indevidamente códigos de acesso login e/ou senha de outros usuários;</li>
            <li>
              Não reproduzir, sob qualquer forma os materiais e conteúdos do Curso Preparatório ANCORD, sob pena de responder civil e criminalmente
              perante a CONTRATADA e terceiros, nos termos da Lei n° 9.610/68, assim como da Lei n° 9.609/98, por violação dos direitos autorais dos
              materiais e conteúdos do Curso Preparatório ANCORD, assim como violação da propriedade intelectual, devendo o uso de todo o conteúdo
              produzido, ser feito exclusivamente em âmbito próprio e privado pelo(a) CONTRATANTE;
            </li>
            <li>
              Não ceder a terceiros seu nome de usuário, login e senha, uma vez que será responsável por quaisquer encargos e atribuições decorrentes
              da utilização dos mesmos, devendo tomar todas as medidas necessárias para IMPEDIR a utilização de todo o material, conteúdo e plataforma
              MELVER de maneira indevida por estranhos ao presente instrumento. Caso a CONTRATADA venha a tomar conhecimento da permissão ou uso do
              acesso exclusivo do(a) CONTRATANTE a/por outro indivíduo, a CONTRATADA poderá bloquear o login do(a) CONTRATANTE, sendo tomadas as
              providências legais cabíveis;
            </li>
            <li>
              Não propagar vírus de computador e programas invasivos ou outras formas de programas computacionais, autorreplicantes ou não, que
              prejudiquem a operação das redes e de computadores individuais;
            </li>
            <li>
              Não tentar burlar o sistema de segurança de computadores para os quais não possua autorização de acesso, assim como não corromper ou
              destruir dados, arquivos ou programas;
            </li>
            <li>Não plagiar, piraterar, muito menos comercializar, no todo ou em parte, qualquer conteúdo e material oferecidos;</li>
            <li>
              O(A) CONTRATANTE autoriza que seu nome completo e número do CPF sejam lançados em todas as páginas das apostilas fornecidas pela
              CONTRATADA, como também em marca d’água em todas as videoaulas produzidas pela CONTRATADA, garantindo, assim, a exclusividade de todo o
              material e conteúdo produzidos para a utilização pessoal e individualizada do(a) CONTRATANTE, não configurando, assim, qualquer violação
              da CONTRATADA à LGPD;
            </li>
            <li>Por fim, não veicular mensagens que possam vir a ser consideradas ofensivas e subversivas ou que firam princípios éticos.</li>
          </ol>
          <p>&nbsp;</p>
          <p style={{ textAlign: 'center' }}>
            <strong>III - CONDIÇÕES GERAIS:</strong>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 6ª - Do idioma/legislação:</strong> As partes contratantes, desde já, ajustam para todos os fins de direito que o
            presente instrumento, bem como os eventuais anexos, aditivos e aditamentos, serão elaborados em língua portuguesa (português/Brasil),
            renunciando-se outros idiomas, e serão regidos pela legislação existente no território nacional, em especial a Lei nº 10.406/02.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 7ª - Da Vigência, eficácia e cessão dos direitos e obrigações decorrentes do presente instrumento:</strong> O negócio
            jurídico passará a vigorar entre as partes a partir da assinatura digital (aceite) deste, sendo certo que, quaisquer alterações, emendas
            ou aditamentos a este instrumento, somente produzirão efeitos se forem realizados por escrito e assinados pelas partes contratantes.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo único: Os direitos e as obrigações decorrentes deste instrumento não poderão ser cedidos ou sub-rogados a terceiros estranhos ao
            pacto sem anuência escrita das partes. O descumprimento do aqui ajustado implicará em infração contratual grave, resultando na imediata
            rescisão do negócio jurídico, sob pena das medidas judiciais cabíveis.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 8ª - Do caráter de exclusividade:</strong> O presente instrumento é firmado em caráter de exclusividade, não podendo o(a)
            CONTRATANTE utilizar todo e qualquer conteúdo desenvolvido pela CONTRATADA para qualquer outra pessoa, física ou jurídica.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 9ª - Princípios corporativos:</strong> A CONTRATADA, desde já, compromete-se a respeitar e aplicar toda a legislação e/ou
            regulamentação federal, estadual e/ou municipal aplicáveis para a execução do presente instrumento, em especial as legislações referentes
            ao meio ambiente, diretos trabalhistas e previdenciários, bem como os princípios e as políticas a seguir descritos:
          </p>

          <ol>
            <li>
              Não empregar ou contratar para o trabalho crianças e/ou menores em desacordo com a legislação trabalhista vigente, em qualquer atividade
              relacionada com o objeto do presente contrato;
            </li>
            <li>Providenciar aos seus empregados, prepostos e demais pessoas credenciadas um ambiente seguro de trabalho;</li>
            <li>
              Tratar todos os empregados, prepostos e demais pessoas credenciadas com respeito e dignidade e não tolerar que eles sejam vítimas de
              qualquer forma de discriminação ou assédio (seja sexual ou moral);
            </li>
            <li>Não tolerar qualquer tipo de discriminação ou assédio por parte de seus empregados;</li>
            <li>Não se envolver em qualquer tipo de ação abusiva contra os direitos humanos;</li>
            <li>
              Não empregar ou contratar empresas que utilizem o trabalho forçado ou escravo em qualquer atividade relacionada com a prestação de
              serviços para a contratada;
            </li>
            <li>Não tolerar qualquer forma de corrupção, inclusive, extorsão e suborno;</li>
            <li>Garantir que suas ações não desrespeitem o meio ambiente.</li>
          </ol>
          <p>&nbsp;</p>
          <p style={{ textAlign: 'center' }}>
            <strong>IV – PROTEÇÃO E PRIVACIDADE DOS DADOS PESSOAIS</strong>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 10ª</strong> <strong>- Da proteção de dados pessoais:</strong> A CONTRATADA atenderá às exigências da Lei Geral de
            Proteção de Dados Pessoais (LGPD) – Lei nº 13709/2008.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo único: A CONTRATADA monitorará, por meios adequados, sua própria conformidade e a de seus funcionários e suboperadores com as
            respectivas obrigações de proteção de dados, caso aplicável.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 11ª - Responsabilidade dos Dados</strong>: O(A) CONTRATANTE se responsabilizará pelos dados que inserir na plataforma ou
            eventualmente compartilhados com a CONTRATADA.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo primeiro: A CONTRATADA se compromete a tratar como confidencial todos os dados a que vier a ter acesso em razão do cumprimento
            das disposições deste contrato.
          </p>
          <p>&nbsp;</p>
          <p>Parágrafo segundo: &nbsp;A CONTRATADA tratará os dados com o nível de segurança exigido pela Legislação vigente.</p>
          <p>&nbsp;</p>
          <p>
            Parágrafo terceiro:&nbsp; O(A) CONTRATANTE autoriza o lançamento de seu nome e CPF em todo e qualquer material e conteúdo produzidos pela
            CONTRATADA (impresso, eletrônico, videoaulas etc.).
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 12ª - Do armazenamento de Dados:</strong> Os Dados coletados serão armazenados em ambiente seguro e controlado da
            CONTRATADA, ou de terceiro (pessoa física ou jurídica) por ela contratado.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 13ª - Da Legalidade dos Dados:</strong> A CONTRATADA não se obrigará a processar, tratar ou armazenar quaisquer dados
            do(a) CONTRATANTE se houver razões para crer que tal processamento, tratamento ou armazenamento possa imputar à CONTRATADA infração de
            qualquer lei aplicável.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 14ª - Da Segurança da informação:</strong> A CONTRATADA prestará os serviços mediante esforço razoável em conformidade
            com controles de segurança da informação e com a legislação aplicável.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 15ª - Do uso indevido:</strong> Caso a CONTRATADA, a seu critério, constate que a plataforma contratada seja utilizada
            para quaisquer fins ilegais, ilícitos, que afrontem a legislação de proteção de dados pessoais ou contrários à moralidade pelo(a)
            CONTRATANTE, a CONTRATADA comunicará o(a) CONTRATANTE para que cesse o uso da plataforma contratada para tal fim no prazo de cura
            estabelecido neste contrato, sujeito as mesmas consequências também estabelecidas em caso de descumprimento.
          </p>
          <p>&nbsp;</p>
          <p style={{ textAlign: 'center' }}>
            <strong>V - DESISTÊNCIAS, CANCELAMENTOS E REEMBOLSOS</strong>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 16ª - Da desistência:</strong> Nos termos do art. 49 do Código de Defesa do Consumidor, o(a) CONTRATANTE poderá, no prazo
            de 7 (sete) dias contados da liberação da primeira aula, exercer o direito de arrependimento, sendo restituído integralmente o valor pago.
          </p>
          <p>&nbsp;</p>
          <p>Parágrafo primeiro: Decorrido o prazo descrito nesta cláusula, não caberá restituição em caso de desistência do(a) CONTRATANTE.</p>
          <p>&nbsp;</p>
          <p>
            Parágrafo segundo: Para solicitar o cancelamento, o(a) aluno(a) CONTRATANTE deverá formalizar a expressa opção (desistência/cancelamento),
            mediante envio de e-mail para:{' '}
            <a href="mailto:financeiro@melver.com.br" style={{ color: '#00BFBE' }}>
              financeiro@melver.com.br
            </a>
            . O valor pago será integralmente devolvido em até 60 (sessenta) dias após a confirmação do recebimento do pedido de cancelamento pela
            CONTRATADA.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo terceiro: Além da possibilidade de reembolso previsto acima, o(a) CONTRATANTE também terá direito à restituição dos valores
            pagos em caso de erros ou problemas técnicos comprovados, que impossibilitem o acesso aos cursos contratados.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo quarto: Após a emissão do certificado, não será concedido o cancelamento e o reembolso de quaisquer valores em hipótese alguma.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo quinto: Em caso de pagamento por boleto bancário, o reembolso será efetuado somente&nbsp;na conta bancária do usuário (vinculado
            ao CPF) que realizou a compra.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo sexto: Demais hipóteses não previstas neste instrumento, ensejam o contato direto com a equipe da CONTRATADA, para averiguação
            de alternativas visando a satisfação de ambas as partes contratantes.
          </p>
          <p>&nbsp;</p>
          <p style={{ textAlign: 'center' }}>
            <strong>VI – NOTAS FISCAIS</strong>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 17ª - Da emissão de notas fiscais:</strong> Em razão da particularidade do Curso Preparatório ANCORD, considerando que a
            CONTRATADA será a responsável pela produção, confecção, edição, formatação e disponibilização de todo o material e conteúdo fornecidos
            ao(à) CONTRATANTE, do montante global ajustado na cláusula 1ª, parágrafo único, 75% (setenta e cinco por cento) se referem à prestação de
            serviços tipificada pelo CNAE 58.11-5-00, com a emissão de Nota Fiscal Eletrônica proporcional à quantia.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo único: Em outro giro, 25% (vinte e cinco por cento) do montante global ajustado na cláusula 1ª, parágrafo único, se referem aos
            serviços indicados no CNAE 85.99-6-04, com a emissão de Nota Fiscal Eletrônica igualmente proporcional à quantia.
          </p>
          <p>&nbsp;</p>
          <p style={{ textAlign: 'center' }}>
            <strong>VII – EFICÁCIA DO CONTRATO ELETRÔNICO</strong>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 18ª - Da eficácia eletrônica do presente instrumento:</strong> As partes contratantes reconhecem a veracidade,
            autenticidade, integridade, validade e eficácia deste contrato e seus termos, nos moldes do art. 219 do Código Civil/02, em formato
            eletrônico e/ou assinado pelos contratantes (CONTRATADA e CONTRATANTE) digitalmente.
          </p>
          <p>&nbsp;</p>
          <p>
            Parágrafo único: Por se tratar de aceitação eletrônica, que se fará mediante o “clique do botão ACEITO” pelo(a) CONTRATANTE, este declara
            total aceite aos termos ajustados, reconhecendo que leu e está ciente e de pleno acordo com todos os termos e com todas as condições deste
            contrato.
          </p>
          <p>&nbsp;</p>
          <p style={{ textAlign: 'center' }}>
            <strong>VIII - FORO</strong>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cláusula 19ª - Do Foro:</strong> Fica eleito o foro central da comarca de Florianópolis/Capital, com renúncia de qualquer outro,
            por mais privilegiado que seja, para dirimir quaisquer divergências oriundas deste.
          </p>

          <Button mt={6} onClick={hideTerm}>
            Fechar
          </Button>
        </Box>
      </WrapperScroll>
    </Opacity>
  </>
);

export default Term;
